import React from "react";
import { useSelector } from "react-redux";
import { parseUrl } from "query-string";
import get from "lodash/get";

import AccountModal from "../../login/AccountModal";
import { AppLogo } from "../../layouts/app-logo";

import "./user-login.m.css";

const UserLoginPage = () => {
  const qtConfig = useSelector((state) => get(state, ["qt"], {}));
  const publisherAttributes = get(qtConfig, ["config", "publisher-attributes"], {});
  const currentPath = get(qtConfig, ["currentPath"], "");
  const search = typeof global !== "undefined" && global.location ? global.location.search : "";
  const params = parseUrl(search);
  const callbackUrlFromQuery = get(params, ["query", "callback_uri"]);
  const callbackUrl = callbackUrlFromQuery === "undefined" || !callbackUrlFromQuery ? null : callbackUrlFromQuery;
  const isLoginUrl = !!currentPath?.includes('user-login');

  const handleBack = (e) => {
    e.preventDefault();
    if (callbackUrl) {
      window.location.href = callbackUrl;
    } else if (
      typeof window !== "undefined" &&
      document.referrer &&
      document.referrer.includes(window.location.host) &&
      !document.referrer.includes("/user-login")
    ) {
      window.location.href = document.referrer;
    } else if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div styleName="user-login-wrapper">
      <div styleName="wrapper">
        <div styleName="header">
          <a href={callbackUrl || "#"} onClick={handleBack} styleName="back-btn" style={{ color: "#ac3040" }}>
            {" "}
            &#x2190; Takaisin{" "}
          </a>
          <AppLogo width="140" isUserLoginPage={isLoginUrl} />
        </div>
        <AccountModal isPopup={false} customCallbackUrl={callbackUrl} />
      </div>
    </div>
  );
};

export { UserLoginPage };
